import { AccordionComponent } from '@builder.io/widgets/dist/lib/components/Accordion';

export default AccordionComponent;
